module.exports = __webpack_public_path__ + "static/media/32 Turtle.41a71c41.jpg";